import React from 'react';

import DateComponent from 'brandComponents/DateComponent';
import {EDateComponentType} from 'brandComponents/DateComponent/IDateComponent';
import OrderStatus from 'brandComponents/OrderStatus';

import {IOrderDetailsAccordionHeadingProps} from './IOrderDetailsAccordionHeading';

const OrderDetailsAccordionHeading = ({
	creationDate,
	status,
	orderNumber,
	returnAuthorizationStatusLabel,
}: IOrderDetailsAccordionHeadingProps) => (
	<>
		<span className="order-details__accordion__heading__data">
			<DateComponent
				value={creationDate}
				showLocalizedDate
				dateType={EDateComponentType.DATE_SHORT}
				timeStyle={null}
			/>
		</span>
		<span className="order-details__accordion__heading__status">
			<OrderStatus status={status} />
		</span>
		<span className="order-details__accordion__heading__order">{orderNumber}</span>
		<span className="order-details__accordion__heading__return">{returnAuthorizationStatusLabel}</span>
	</>
);

export default OrderDetailsAccordionHeading;
